import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Button';
import FormPopup from '../../../Operational/FormPopup';
import Loader from '../../../Loader';
import Form from './Form';
import { makeStyles } from '@material-ui/core';
import cn from 'classnames';
import { t } from 'i18next';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingBottom: '1.2rem',
    paddingTop: '1.2rem',
    display: 'flex',
    justifyContent: 'flex-start',
  },
}));

const FormDataPopulation = ({
  className,
  subFields,
  submitCallback,
  initialValues,
  validationSchema,
  formHeader,
  buttonText,
  openForm,
}) => {
  const [showForm, setShowForm] = useState();
  const [loading, setLoading] = useState();
  const classes = useStyles();

  useEffect(() => {
    if (openForm) {
      toggleForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleButtonClick = e => {
    e.preventDefault();
    toggleForm();
  };

  const handleSubmit = async values => {
    setLoading(true);

    if (typeof submitCallback === 'function') {
      await submitCallback({ values });
    }
    setShowForm(false);
    setLoading(false);
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  return (
    <div className={cn(classes.wrapper, className)}>
      <Button
        text={t(buttonText)}
        onClick={handleButtonClick}
        size="auto"
        icon={<FileCopyIcon />}
      />
      {showForm && (
        <FormPopup
          closePopup={toggleForm}
          headerTitle={t(formHeader)}
          form={
            loading ? (
              <Loader outline />
            ) : (
              <Form
                initialValues={initialValues}
                validationSchema={validationSchema}
                fields={subFields}
                onSubmit={handleSubmit}
                closeForm={toggleForm}
              />
            )
          }
        />
      )}
    </div>
  );
};

FormDataPopulation.propTypes = {
  subFields: PropTypes.array,
  className: PropTypes.string,
  submitCallback: PropTypes.func,
  initialValues: PropTypes.object,
  validationSchema: PropTypes.object,
  formHeader: PropTypes.string,
  buttonText: PropTypes.string,
  openForm: PropTypes.bool,
};

export default FormDataPopulation;
